import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  Checkbox,
  FormGroup,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import axios from "axios";
import { forwardRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import AuthHeader from "../../../Auth";
import CustomAutocomplete from "../../../Components/AutoComplete/AutoComplete";
import { useNavigate } from "react-router-dom";
import UnLock from "../../../GlobalFunction/UnLock";
import axiosInstance from "../../../lib/axios";
import AddIcon from "@mui/icons-material/Add";

let pincity = [];
const StepperMst1 = ({
  index,
  mode,
  CompanyData,
  Cities,
  AllTextDisabled,
  AllButtonDisabled,
  addModeDis,
  viewModeDis,
  stepToNext,
  Status,
  setStatus,
  setMode,
  AllfieldStepperData,
  Flag,
  fetchCompanyData,
  setTableData,
  CompanyId,
}) => {
  const { register, setValue, reset, watch, getValue } = useForm();
  const [PinCity, setPincity] = useState([]);
  const [SelectedPinId, setSelectedPinId] = useState(" ");
  const [selectedImage, setselectedImage] = useState("");
  const [localStatus, setLocalStatus] = useState("1");
  const navigate = useNavigate();

  const openNewTab = () => {
    window.open("/pincode");
  };

  useEffect(() => {
    if (PinCity.length > 0) {
      handlePinIdChange();
    }
  }, [PinCity]);

  useEffect(() => {
    if (mode === "view" && CompanyData.length > 0) {
      let fieldObj = watch();
      for (let key in fieldObj) {
        setValue(key, AllfieldStepperData[key]);
      }
      let Pinobj = { target: { value: watch("PinCode") } };
      let AreaObj = { target: { value: AllfieldStepperData["PinID"] } };
      handlePinChange(Pinobj);

      setselectedImage(CompanyData[index]["CoLogo"]);
      // setStatus(CompanyData[index]["Status"]);
    } else if (mode === "add") {
      if (!Flag) {
        resetFunc();
      } else {
        let Pinobj = { target: { value: AllfieldStepperData["PinCode"] } };
        let AreaObj = { target: { value: AllfieldStepperData["PinID"] } };
        handlePinChange(Pinobj);

        for (let key in AllfieldStepperData) {
          setValue(key, AllfieldStepperData[key]);
        }
      }
    }
  }, [CompanyData, index, mode, Flag]);

  const resetFunc = () => {
    reset({
      area: "",
      CoAbrv: "",
      CoCin: "",
      CoEmail: "",
      CoName: "",
      CoPan: "",
      CoRegAdd: "",
      CoTan: "",
      CoMob: "",
      CoTel: "",
      Designation: "",
      GSTIN: "",
      IeCode: "",
      MsmeCat: "",
      MsmeNo: "",
      MsmeType: "",
      PinID: "",
      Remark1: "",
      Remark2: "",
      TdsCircle: "",
      TdsPerson: "",
      Website: "",
      WorkAddr: " ",
      PinCode: "",
      CityId: "",
      CoLogo: "",
    });
    setselectedImage("");
    setStatus("1");
  };

  const handlePinChange = async (e) => {
    let { value } = e.target;
    console.log(value, value.length);
    let val = value.trim();
    if (val.length === 6) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodewisearea`,
          {
            PinCode: parseInt(value),
          }
        );
        const data = response.data.Data;

        if (data && data.length > 0) {
          setPincity(data);
          pincity = data;
          return;
        } else {
          setPincity([]);
          setValue("City", "");
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    }
    setValue("City", "");
    setPincity([]);
  };

  const handleClick = () => {};

  const handleNameChange = (e) => {
    let cityname = e.target.value;
  };

  useEffect(() => {
    const statusFromForm = watch("Status"); // Get the current value from the form
    if (statusFromForm) {
      setStatus(statusFromForm); // Update the state with the form's value
    }
  }, [watch]);

  const handleClickNext = () => {
    const { CoName, CityId, PinID, CoAbrv, PinCode } = watch();
    console.log(selectedImage);
    console.log(Status);
    setValue("CoLogo", selectedImage);
    setValue("Status", Status);
    console.log("watch", watch());
    // setValue("PinID", SelectedPinId);
    if (
      CoName != "" &&
      CityId != "" &&
      PinID != "" &&
      CoAbrv != "" &&
      PinCode != ""
    ) {
      stepToNext(watch());
    } else {
      toast.error("Please Fill The Mandatory Filled");
    }
  };

  const HandleNextStep = () => {};

  const handleCancel = async () => {
    // if (CompanyData.length > 0) {
    //   let fieldObj = watch();
    //   for (let key in fieldObj) {
    //     setValue(key, CompanyData[index][key]);
    //     // setValue(key, AllfieldStepperData[key]);
    //   }
    //   setTableData(CompanyData[0].CobrMstList);
    //   let Flag = await UnLock(CompanyId, "MstCo", "CoMstId");
    //   console.log(Flag);
    //   switch (Flag) {
    //     case 0: break;
    //     case 1: toast.info("Problem To Unlocked Record", { autoClose: 500 });
    //       break;
    //     default: toast.info("Something Went Wrong", { autoClose: 500 });
    //   }

    // } else {
    //   fetchCompanyData(1, "L");
    // }
    // viewModeDis();
    // setMode("view");

    if (mode === "add") {
      CompanyData.length > 0
        ? await fetchCompanyData(CompanyId, "R")
        : await fetchCompanyData(1, "L");
    } else {
      await UnLock(CompanyId, "MstCo", "CoMstId");
      await fetchCompanyData(CompanyId, "R");
    }
  };

  const handleFileChange = (event) => {
    console.log("obj", watch());
    const file = event.target.files[0];
    console.log("file", file);
    if (file) {
      const reader = new FileReader();

      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then((base64String) => {
          console.log("base64String", base64String);
          setValue("CoLogo", base64String);
          setselectedImage(base64String);
        })
        .catch((err) => {
          console.error("Error reading file:", err);
          toast.error("Error reading file. Please try again.");
        });
    }
  };

  const handlePinIdChange = async () => {
    console.log("PinId", watch("PinID"));
    console.log("PinCity", PinCity);
    if (watch("PinID") === undefined || watch("PinID") === "") return;
    let getObj = PinCity.find((obj) => obj.Id === watch("PinID"));
    console.log("getobj ", getObj);
    let AreaName = getObj?.Name;
    let PinCode = getObj?.PinCode;
    if (getObj) {
      try {
        const response = await axiosInstance.post(
          `pincodeMst/getdrppincodeAreawise_datafill`,
          {
            AreaName,
            PinCode,
          }
        );
        const data = response.data.Data;
        console.log("pindata", data);
        if (data && data.length > 0) {
          setValue("City", data[0].CityName);
        } else {
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
      }
    }
  };

  useEffect(() => {
    if (Status) {
      setLocalStatus(Status);
    }
  }, [Status]);

  const handleChangeStatus = (e) => {
    let status = e.target.checked ? "1" : "0";
    setLocalStatus(status);
    setStatus(status);
    console.log("statuscheck", status);
  };

  console.log("Cities Data:", Cities);
  console.log("Current Watch Value:", watch("CityId"));
  console.log(
    "Matched City:",
    Cities.find((city) => city.Id === watch("CityId"))
  );

  return (
    <Grid container spacing={1}>
      {/* <ToastContainer /> */}
      <Grid container spacing={1}>
        <Grid item lg={8} md={8} xs={12}>
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Grid container spacing={0.5}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      Company Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="companyName"
                  variant="filled"
                  {...register("CoName")}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={watch("CoName") || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      Short Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="shortName"
                  variant="filled"
                  {...register("CoAbrv")}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={watch("CoAbrv") || ""}
                />
              </Grid>
              {/* <Grid item xs={12} md={3}>
                
                  <select
                    id="jurisdiction"
                    name="jurisdiction"
                    {...register("CityId")}
                    value={watch("CityId")}
                    style={{
                      height: "42px",
                      width: "14vw",
                      borderColor: "gray",
                      borderRadius: "5px",
                      padding: "0 10px",
                      fontSize: "16px",
                      color: "gray",
                    }}
                    disabled={AllTextDisabled} 
                  >
                  
                    <option value="" disabled className="custom-textfield">
                      Select Jurisdiction{" "}
                      <span style={{ color: "red" }}>*</span>
                    </option>

                   
                    {Cities?.map((option) => (
                      <option key={option.Id} value={option.Id}>
                        {option.Name}
                      </option>
                    ))}
                  </select>
                </Grid> */}
              {/* <Grid item xs={12} md={3} className='form_field'>
                  <FormControl variant="filled" fullWidth className="custom-select">
                    <InputLabel id="areaName-select-label">Juridiction  <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Select
                      labelId="areaName-select-label"
                      id="PinId"
                      name="CityId"
                      value={watch('CityId') || ""}
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                      {...register("CityId")}
                    >

                      {Cities.length > 0 && Cities.map(obj =>
                        <MenuItem value={obj.Id} key={obj.Id} >
                          {obj.Name}
                        </MenuItem>

                      )}


                    </Select>
                  </FormControl>


                </Grid> */}

              {/* <Grid item xs={12} md={3} className='form_field'>
                  <FormControl variant="filled" fullWidth className="custom-select">
                    <InputLabel id="areaName-select-label">Juridiction  <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Select
                      labelId="areaName-select-label"
                      id="PinId"
                      name="CityId"
                      value={watch('CityId') || ""}
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                      {...register("CityId")}
                    >

                      {Cities.length > 0 && Cities.map(obj =>
                        <MenuItem value={obj.Id} key={obj.Id} >
                          {obj.Name}
                        </MenuItem>

                      )}


                    </Select>
                  </FormControl>

             


                </Grid> */}
              <Grid item xs={12} md={3} className="form_field">
                {/* <FormControl
                  variant="filled"
                  fullWidth
                  className="custom-select"
                >
                  <InputLabel id="areaName-select-label">
                    Juridiction <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="areaName-select-label"
                    id="PinId"
                    name="CityId"
                    value={watch("CityId") || ""}
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    {...register("CityId")}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200,
                          overflow: "auto",
                        },
                      },
                    }}
                  >
                    {Cities.length > 0 &&
                      Cities.map((obj) => (
                        <MenuItem value={obj.Id} key={obj.Id}>
                          {obj.Name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl> */}

                <CustomAutocomplete
                  options={Cities}
                  id="CityId-autocomplete"
                  name="CityId"
                  label={
                    <span>
                      Juridiction <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={
                    Cities.find((city) => city.Id === watch("CityId")) || null
                  }
                  {...register("CityId")}
                  disabled={AllTextDisabled}
                />
              </Grid>
            </Grid>
            <Grid container spacing={0.5}>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="PAN No"
                  name="panN"
                  variant="filled"
                  {...register("CoPan")}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={watch("CoPan") || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="GST No"
                  name="gstNo"
                  variant="filled"
                  {...register("GSTIN")}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={watch("GSTIN") || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="CIN No"
                  name="cinNo"
                  variant="filled"
                  {...register("CoCin")}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={watch("CoCin") || ""}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="TAN No"
                  name="tanNo"
                  variant="filled"
                  {...register("CoTan")}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={watch("CoTan") || ""}
                />
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} xs={12}>
              {/* <Grid container spacing={3}> */}
              <Box display="flex" flexDirection="column" gap={1}>
                <Grid container spacing={0.5}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="IE Code"
                      name="IeCode"
                      variant="filled"
                      className="custom-textfield"
                      {...register("IeCode")}
                      disabled={AllTextDisabled}
                      value={watch("IeCode") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="TDS Circle"
                      name="TdsCircle"
                      variant="filled"
                      className="custom-textfield"
                      {...register("TdsCircle")}
                      disabled={AllTextDisabled}
                      value={watch("TdsCircle") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="TDS Person"
                      name="TdsPerson"
                      variant="filled"
                      className="custom-textfield"
                      {...register("TdsPerson")}
                      disabled={AllTextDisabled}
                      value={watch("TdsPerson") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Designation"
                      name="Designation"
                      variant="filled"
                      className="custom-textfield"
                      {...register("Designation")}
                      disabled={AllTextDisabled}
                      value={watch("Designation") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Email ID"
                      name="emailID"
                      variant="filled"
                      className="custom-textfield"
                      {...register("CoEmail")}
                      disabled={AllTextDisabled}
                      value={watch("CoEmail") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Tel No"
                      name="telNo"
                      variant="filled"
                      className="custom-textfield"
                      {...register("CoTel")}
                      disabled={AllTextDisabled}
                      value={watch("CoTel") || ""}
                    />
                  </Grid>

                  {/* Third column: Mobile No */}
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Mob No"
                      name="CoMob"
                      variant="filled"
                      className="custom-textfield"
                      {...register("CoMob")}
                      disabled={AllTextDisabled}
                      value={watch("CoMob") || ""}
                    />
                  </Grid>

                  {/* Fourth column: Website */}
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Website"
                      name="Website"
                      variant="filled"
                      className="custom-textfield"
                      {...register("Website")}
                      disabled={AllTextDisabled}
                      value={watch("Website") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="MSME No"
                      name="MsmeNo"
                      variant="filled"
                      className="custom-textfield"
                      {...register("MsmeNo")}
                      sx={{
                        "& .MuiInputLabel-root": {
                          marginBottom: "8px",
                        },
                        "& .MuiFilledInput-root": {
                          marginTop: "4px",
                        },
                      }}
                      disabled={AllTextDisabled}
                      value={watch("MsmeNo") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    {/* <TextField
                        fullWidth
                        label="MSME Cat"
                        name="MsmeCat"
                        variant="filled"
                        className="custom-textfield"
                        {...register("MsmeCat")}
                        disabled={AllTextDisabled}
                        value={watch('MsmeCat') || ""}
                      /> */}

                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="areaName-select-label">
                        MSME Cat
                      </InputLabel>
                      <Select
                        labelId="areaName-select-label"
                        id="MsmeCat"
                        name="MsmeCat"
                        value={watch("MsmeCat") || ""}
                        className="custom-textfield"
                        disabled={AllTextDisabled}
                        {...register("MsmeCat")}
                      >
                        <MenuItem value={"M"}>Micro</MenuItem>
                        <MenuItem value={"N"}>Medium</MenuItem>
                        <MenuItem value={"S"}>Small</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    {/* <TextField
                        fullWidth
                        label="MSME Type"
                        name="MsmeType"
                        variant="filled"
                        className="custom-textfield"
                        {...register("MsmeType")}
                        disabled={AllTextDisabled}
                        value={watch('MsmeType') || ""}
                      /> */}

                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="areaName-select-label">
                        MSME Type
                      </InputLabel>
                      <Select
                        labelId="areaName-select-label"
                        id="MsmeType"
                        name="MsmeType"
                        value={watch("MsmeType") || ""}
                        className="custom-textfield"
                        disabled={AllTextDisabled}
                        {...register("MsmeType")}
                      >
                        <MenuItem value={"M"}>Manufacturing</MenuItem>
                        <MenuItem value={"S"}>Service</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Bank Details"
                      name="Remark1"
                      variant="filled"
                      className="custom-textfield"
                      {...register("Remark1")}
                      disabled={AllTextDisabled}
                      value={watch("Remark1") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    {/* <TextField
                      fullWidth
                      label={
                        <span>
                          Pin Code <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="pinCode"
                      variant="filled"
                      className="custom-textfield"
                      {...register("PinCode", { onChange: handlePinChange })}
                      disabled={AllTextDisabled}
                      value={watch("PinCode") || ""}
                    /> */}
                    <TextField
                      fullWidth
                      label={
                        <span>
                          Pin Code <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="PinCode"
                      variant="filled"
                      className="custom-textfield"
                      {...register("PinCode", { onChange: handlePinChange })}
                      disabled={AllTextDisabled}
                      value={watch("PinCode") || ""}
                      InputProps={{
                        endAdornment: !AllTextDisabled &&(
                          <InputAdornment position="end">
                            <AddIcon
                              onClick={openNewTab}
                              style={{ cursor: "pointer" }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3} className="form_field">
                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="areaName-select-label">
                        Area <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="areaName-select-label"
                        id="PinId"
                        name="PinId"
                        value={watch("PinID") || ""}
                        className="custom-textfield"
                        disabled={AllTextDisabled}
                        {...register("PinID", { onChange: handlePinIdChange })}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200, // Set the maximum height for the dropdown menu
                              overflow: "auto", // Allow scrolling if content exceeds the max height
                            },
                          },
                        }}
                      >
                        {PinCity.length > 0 &&
                          PinCity.map((obj) => (
                            <MenuItem value={obj.Id} key={obj.Id}>
                              {obj.Name}
                            </MenuItem>
                          ))}

                        <MenuItem value="2">No areas available</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="City"
                      name="City"
                      variant="filled"
                      className="custom-textfield"
                      {...register("City")}
                      disabled={AllTextDisabled}
                      value={watch("City") || ""}
                    />
                  </Grid>

                  {/* Remark2 Field */}
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Remark2"
                      name="Remark2"
                      variant="filled"
                      {...register("Remark2")}
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                      value={watch("Remark2") || ""}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Reg Address"
                      name="regAddress"
                      multiline
                      rows={1}
                      variant="filled"
                      className="custom-textfield"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "70px",
                        },
                        "& .MuiInputBase-input": {
                          resize: "vertical",
                        },
                        "& .MuiFilledInput-root": {
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                          "&.Mui-focused": {
                            backgroundColor: "transparent",
                          },
                        },
                      }}
                      {...register("CoRegAdd")}
                      disabled={AllTextDisabled}
                      value={watch("CoRegAdd") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Work Address"
                      name="WorkAddress"
                      multiline
                      rows={1}
                      variant="filled"
                      className="custom-textfield"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "70px",
                        },
                        "& .MuiInputBase-input": {
                          resize: "vertical",
                        },
                        "& .MuiFilledInput-root": {
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                          "&.Mui-focused": {
                            backgroundColor: "transparent",
                          },
                        },
                      }}
                      {...register("WorkAddr")}
                      disabled={AllTextDisabled}
                      value={watch("WorkAddr") || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={AllTextDisabled}
                            {...register("Status")}
                            checked={localStatus === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Grid>
        <Grid
          item
          lg={2}
          md={2}
          xs={12}
          display="flex"
          alignItems="center"
          sx={{ marginTop: "-10px", marginLeft: "50px" }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            border="1px solid #ccc"
            borderRadius={1}
            width={150}
            height={145}
            overflow="hidden"
            position="relative"
            sx={{ cursor: "pointer", border: 1, borderColor: "black" }}
          >
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="Uploaded Logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Typography variant="body2" color="textSecondary">
                Browse
              </Typography>
            )}

            <input
              id="upload-photo"
              type="file"
              accept="image/*"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
              }}
              {...register("CoLogo")}
              onChange={handleFileChange}
              disabled={AllTextDisabled}
            />
          </Box>
          <label htmlFor="upload-photo">
            <Button component="span" style={{ marginTop: "5px" }}>
              Upload Image
            </Button>
          </label>
        </Grid>

        {/* <Grid item lg={12} md={12} xs={12}  sx={{border:1 ,borderColor:"black"}}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Grid container spacing={3}></Grid>
            </Box>
          </Grid> */}

        {/* Wrapping the entire Grid in a Box for spacing */}

        {/* <Grid item lg={12} md={12} xs={12}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="MSME No"
                    name="MsmeNo"
                    variant="filled"
                    className="custom-textfield"
                    {...register("MsmeNo")}
                    sx={{
                      "& .MuiInputLabel-root": {
                        marginBottom: "8px",
                      },
                      "& .MuiFilledInput-root": {
                        marginTop: "4px",
                      },
                    }}
                    disabled={AllTextDisabled}
                    value={watch('MsmeNo') || ""}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="MSME Cat"
                    name="MsmeCat"
                    variant="filled"
                    className="custom-textfield"
                    {...register("MsmeCat")}
                    disabled={AllTextDisabled}
                    value={watch('MsmeCat') || ""}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="MSME Type"
                    name="MsmeType"
                    variant="filled"
                    className="custom-textfield"
                    {...register("MsmeType")}
                    disabled={AllTextDisabled}
                    value={watch('MsmeType') || ""}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Remark1"
                    name="Remark1"
                    variant="filled"
                    className="custom-textfield"
                    {...register("Remark1")}
                    disabled={AllTextDisabled}
                    value={watch('Remark1') || ""}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid> */}
      </Grid>

      <Grid item xs={12} className="form_button">
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleClickNext}
          disabled={AllTextDisabled}
        >
          Next
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleCancel}
          disabled={AllTextDisabled}
        >
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};

export default StepperMst1;
